let basic = [
  {
    path: 'shareMgt',
    meta: {
      title: '分享素材',
      breadcrumb: true
    },
    component: {
      name: 'shareMgt',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '分享素材',
        },
        component: (resolve) => require(['@/views/plat/basicSetting/shareMgt'], resolve)
      },
      {
        path: 'newAdd',
        meta: {
          title: '新增',
          breadcrumb: true
        },
        component: (resolve) => require(['@/views/plat/basicSetting/shareMgt/children/newAdd'],resolve)
      },
      {
        path: 'editor',
        meta: {
          title: '编辑',
          breadcrumb: true
        },
        component: (resolve) => require(['@/views/plat/basicSetting/shareMgt/children/editor'],resolve)
      },
    ]
  },
  {
    path: 'satisfactionRating',
    meta: {
      title: '满意度评价',
      breadcrumb: true
    },
    component: (resolve) => require(['@/views/plat/basicSetting/satisfactionRating'], resolve)
  },
]

export default {
  path: '/basicSetting',
  redirect: '/basicSetting/satisfactionRating',
  meta: {
      title: "基础设置",
      breadcrumb: true
  },
  component: {
      name: 'basicSetting',
      template: '<router-view></router-view>'
  },
  children: basic
}


// WEBPACK FOOTER //
// ./src/router/basicSetting.js